const getCookie = (name) => {
  const parser = (arr) => {
    const result = {};
    arr.forEach((elem) => {
      const [name, value] = elem.split("=");
      result[String(name).trim()] = value;
    });
    return result;
  };
  const cookies = parser(decodeURIComponent(document.cookie).split(";"));
  return cookies[name];
};
export const Cookie = (name, value, expire) => {
  if (!value) {
    return getCookie(name);
  }
  const date = new Date();
  date.setTime(date.getTime() + expire * 86400000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${String(name).trim()}=${value};${expires};path=/`;
  return decodeURIComponent(document.cookie);
};
